var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgResendIcon = function SvgResendIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:email-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.2 5.64155L8 8.56854L12.8 5.64155L8 2.71455L3.2 5.64155ZM14 5.64155V11.4955C14 11.8061 13.8736 12.1039 13.6485 12.3234C13.4235 12.543 13.1183 12.6663 12.8 12.6663H3.2C2.88174 12.6663 2.57652 12.543 2.35147 12.3234C2.12643 12.1039 2 11.8061 2 11.4955V5.64155C2 5.21421 2.234 4.8454 2.582 4.64051L7.65263 1.54506C7.86591 1.41486 8.13409 1.41486 8.34737 1.54506L13.418 4.64051C13.766 4.8454 14 5.21421 14 5.64155Z",
    fill: "#828282"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgResendIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "resend-icon.e1e278efeb5f30727b83ef0b22f07d72.svg";